export default "__VITE_ASSET__D4C46kVG__"